import type { CartError } from 'models/api';

import { mapSeverityToVariant } from './helpers';
import Message from './Message';

interface Props {
	className?: string;
	error: CartError | undefined;
}

export default function CartErrorMessage({ className, error }: Props) {
	if (!error) return null;
	return (
		<Message
			className={className}
			variant={mapSeverityToVariant(error.level)}
			text={error.description}
		/>
	);
}

CartErrorMessage.displayName = 'CartErrorMessage';
